// @flow
import React, { Component } from 'react';
import {
  ErrorP,
  SaveSuccessP,
  SavePromptP,
  SaveOverlayDiv,
  SaveButton
} from './SaveOverlayStyles';

type Props = {
  pristine: boolean,
  submitting: boolean,
  submitSucceeded: boolean,
  error: ?string,
  sidebarOpened: boolean,
  sidebarOpenedDevice: boolean,
  viewportDevice: boolean
};
type State = { pageYOffset: number };

export default class SaveOverlay extends Component<Props, State> {
  state = { pageYOffset: window.pageYOffset };
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll = () => {
    this.setState({ pageYOffset: window.pageYOffset });
  };

  renderMessage = () => {
    if (this.props.error) {
      return <ErrorP>{this.props.error}</ErrorP>;
    } else if (this.props.submitSucceeded && this.props.pristine) {
      return <SaveSuccessP>Saved!</SaveSuccessP>;
    } else if (!this.props.pristine) {
      return <SavePromptP>You have unsaved changes</SavePromptP>;
    }
  };

  render() {
    const triggerHeight = window.innerWidth >= 768 ? 440 : 420;
    const visible =
      this.state.pageYOffset > triggerHeight &&
      (!this.props.pristine || this.props.submitSucceeded);
    return (
      <>
        <SaveOverlayDiv
          visible={visible}
          sidebarOpened={this.props.sidebarOpened}
          sidebarOpenedDevice={this.props.sidebarOpenedDevice}
          viewportDevice={this.props.viewportDevice}
        >
          {this.renderMessage()}
          <>
            <SaveButton
              type="submit"
              value="Save"
              disabled={this.props.pristine || this.props.submitting}
              overlay
            />
          </>
        </SaveOverlayDiv>
      </>
    );
  }
}
